import {
    ActionComponentDefinition,
    LabeledComponentDefinition,
    ValueComponentDefinition,
} from "components/components/Component";
import { InputBaseComponent } from "components/components/InputBaseComponent";
import { Tooltip } from "components/components/tooltip/tooltip";
import { ItemFinderModalDefinition, ItemComposedFinderModalDefinition } from "components/input/searcherWithCode/baseItemFinderElement";


export abstract class SearcherBaseComponent<U extends SearcherBaseDefinition> extends InputBaseComponent<U> {

    constructor(schema: U) {
        super(schema);
        if (schema.labelKey == null || schema.labelKey.length === 0) {
            this.definition.labelWidth = 0;
        }
        this.definition.emptyWidth = this.definition.emptyWidth ?? 0;
        if (this.definition.inputWidth == null) {
            this.definition.inputWidth = 16 - (this.definition.labelWidth || 0) - this.definition.emptyWidth;
        }
        this.definition.width = this.definition.width ?? 16;
        this.definition.labelWidth = this.definition.labelWidth ?? 16;

        if (this.definition.finder != null && this.definition.outputParameterMappings != null) {
            this.definition.outputParameterMappings = this.definition.outputParameterMappings;
        }
        this.definition.hasDetail = this.definition.hasDetail ?? true;
    }

    public renderTemplate(template: any, params?: any): Element {
        let objTemplate: any = Object.assign(
            this.definition,
            params ?? {},
        );
        let jqueryView = $(template(objTemplate));
        this.view = jqueryView[0];
        return this.view;
    }

    public tooltipBindElement(selectors: string) {
        Tooltip.bindElement(this.view.querySelector(selectors));
    }
}

export interface SearcherBaseDefinition extends SearcherDetailDefinition, LabeledComponentDefinition,
    ValueComponentDefinition,
    ActionComponentDefinition {

    inputWidth?: number;
    emptyWidth?: number;

    tabOnEnterButton?: boolean;
    disableFocusKeyboardButton?: boolean;

    finder?: ItemFinderModalDefinition | ItemComposedFinderModalDefinition;
    outputParameterMappings?: ParameterMap[];
}

export interface SearcherCodeDefinition {
    maxlength?: number;
    allowedPattern?: RegExp;
    numericCode?: boolean;
    hiddenCode?: boolean;
    uppercase?: boolean;
    tabOnEnter?: boolean;
    disableFocusKeyboard?: boolean;
}

export interface SearcherDetailDefinition {
    hasDetail?: boolean;
    translateDetail?: boolean;
    tabOnEnterDetail?: boolean;
    disableFocusKeyboardDetail?: boolean;
}

export interface ParameterMap {
    field: string;
    as: string;
}
